import React, { useState, useEffect } from 'react';
import Lottie from 'lottie-react';

const Loading = ({ size = 200, message = '' }) => {
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    // Load the JSON file from public folder
    fetch('/assets/css/Loading/loading.json')
      .then(response => response.json())
      .then(data => {
        setAnimationData(data);
      })
      .catch(error => {
        console.error('Error loading animation:', error);
      });
  }, []);

  if (!animationData) {
    return (
      <div className="loading-container">
        <div className="loading-fallback">Loading...</div>
      </div>
    );
  }

  return (
    <div className="loading-container">
      <div className="loading-animation-wrapper">
        <Lottie 
          animationData={animationData}
          style={{ width: size, height: size }}
          loop={true}
          autoplay={true}
        />
      </div>
      {message && (
        <div className="loading-message">
          {message}
        </div>
      )}
    </div>
  );
};

export default Loading;

